module.exports = __webpack_public_path__ + "img/face7.149426f3.png";